export default __webpack_public_path__ + "static/media/detail_banner1.ab18b178.jpg";